var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39.171 89.282 C 17.572 89.282 0 71.71 0 50.111 c 0 -18.315 12.449 -34 30.273 -38.144 c 0.689 -0.159 1.399 0.185 1.699 0.827 c 0.3 0.643 0.108 1.408 -0.459 1.833 c -8.154 6.12 -12.83 15.467 -12.83 25.646 c 0 17.67 14.375 32.045 32.046 32.045 c 8.346 0 16.252 -3.199 22.263 -9.008 c 0.51 -0.494 1.296 -0.562 1.884 -0.162 c 0.588 0.398 0.815 1.153 0.546 1.811 C 69.362 79.735 55.134 89.282 39.171 89.282 z M 24.465 17.049 C 11.552 22.741 3 35.522 3 50.111 c 0 19.944 16.226 36.171 36.171 36.171 c 12.419 0 23.702 -6.259 30.294 -16.391 c -5.562 3.533 -12.019 5.428 -18.736 5.428 c -19.324 0 -35.046 -15.721 -35.046 -35.045 C 15.683 31.555 18.82 23.393 24.465 17.049 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.884 52.374 c -0.311 0 -0.62 -0.097 -0.882 -0.286 c -0.462 -0.336 -0.693 -0.904 -0.597 -1.468 l 1.416 -8.255 l -5.998 -5.846 c -0.409 -0.398 -0.556 -0.995 -0.38 -1.538 c 0.177 -0.543 0.646 -0.939 1.211 -1.021 l 8.289 -1.205 l 3.707 -7.511 c 0.252 -0.512 0.773 -0.836 1.345 -0.836 s 1.093 0.324 1.345 0.836 l 3.707 7.511 l 8.289 1.205 c 0.564 0.082 1.034 0.478 1.211 1.021 c 0.176 0.543 0.029 1.139 -0.38 1.538 l -5.998 5.847 l 1.416 8.255 c 0.097 0.563 -0.135 1.132 -0.597 1.468 c -0.463 0.336 -1.074 0.38 -1.58 0.114 l -7.413 -3.898 l -7.413 3.898 C 40.362 52.317 40.123 52.374 39.884 52.374 z M 47.995 45.109 c 0.24 0 0.479 0.058 0.698 0.172 l 5.421 2.85 l -1.035 -6.037 c -0.083 -0.486 0.078 -0.983 0.432 -1.328 l 4.386 -4.275 l -6.062 -0.881 c -0.488 -0.071 -0.911 -0.378 -1.129 -0.82 l -2.711 -5.493 l -2.71 5.493 c -0.219 0.442 -0.641 0.75 -1.129 0.82 l -6.062 0.881 l 4.386 4.275 c 0.354 0.345 0.515 0.841 0.432 1.328 l -1.036 6.037 l 5.421 -2.85 C 47.516 45.167 47.755 45.109 47.995 45.109 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 58.871 22.618 c -0.311 0 -0.62 -0.097 -0.882 -0.287 c -0.462 -0.335 -0.693 -0.904 -0.597 -1.467 l 1.04 -6.062 l -4.403 -4.292 c -0.409 -0.399 -0.556 -0.995 -0.38 -1.538 c 0.177 -0.543 0.646 -0.939 1.211 -1.021 l 6.085 -0.884 l 2.723 -5.515 c 0.252 -0.512 0.773 -0.836 1.345 -0.836 l 0 0 c 0.571 0 1.093 0.324 1.345 0.836 l 2.722 5.514 l 6.085 0.884 c 0.564 0.082 1.034 0.478 1.211 1.021 c 0.176 0.543 0.029 1.139 -0.38 1.538 l -4.403 4.292 l 1.04 6.062 c 0.097 0.563 -0.135 1.131 -0.597 1.467 c -0.462 0.336 -1.074 0.38 -1.58 0.114 l -5.442 -2.861 l -5.443 2.861 C 59.35 22.561 59.11 22.618 58.871 22.618 z M 58.3 10.484 l 2.791 2.721 c 0.354 0.345 0.515 0.841 0.432 1.328 l -0.659 3.843 l 3.451 -1.814 c 0.438 -0.23 0.96 -0.229 1.396 0 l 3.45 1.814 l -0.659 -3.843 c -0.083 -0.486 0.078 -0.983 0.432 -1.328 l 2.791 -2.721 l -3.857 -0.561 c -0.488 -0.071 -0.911 -0.378 -1.129 -0.821 l -1.726 -3.496 l -1.727 3.497 c -0.218 0.442 -0.641 0.75 -1.129 0.82 L 58.3 10.484 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.883 54.709 c -0.311 0 -0.62 -0.097 -0.882 -0.286 c -0.462 -0.336 -0.693 -0.904 -0.597 -1.468 l 0.787 -4.589 l -3.334 -3.25 c -0.409 -0.399 -0.556 -0.995 -0.38 -1.538 c 0.177 -0.543 0.646 -0.939 1.211 -1.021 l 4.607 -0.669 l 2.062 -4.176 c 0.252 -0.512 0.773 -0.836 1.345 -0.836 l 0 0 c 0.571 0 1.093 0.324 1.345 0.836 l 2.061 4.175 l 4.608 0.669 c 0.564 0.082 1.034 0.478 1.211 1.021 s 0.029 1.139 -0.38 1.538 l -3.335 3.25 L 87 52.955 c 0.097 0.563 -0.135 1.132 -0.597 1.468 c -0.463 0.336 -1.075 0.379 -1.58 0.114 l -4.121 -2.167 l -4.121 2.167 C 76.361 54.652 76.122 54.709 75.883 54.709 z M 76.128 45.089 l 1.722 1.679 c 0.354 0.345 0.515 0.841 0.432 1.328 l -0.406 2.371 l 2.129 -1.12 c 0.438 -0.229 0.959 -0.229 1.396 0 l 2.129 1.119 l -0.407 -2.37 c -0.083 -0.487 0.078 -0.983 0.432 -1.328 l 1.723 -1.679 l -2.381 -0.346 c -0.488 -0.071 -0.911 -0.378 -1.129 -0.821 l -1.064 -2.157 l -1.065 2.157 c -0.218 0.442 -0.641 0.75 -1.129 0.82 L 76.128 45.089 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.e92ada4d859e8980657bda57af0bd3dc.svg";
export { ForwardRef as ReactComponent };